<template>
  <div class="typo home">
    <section class="title">
      <h3>{{article.title}}</h3>
    </section>

    <section class="content">
      <div v-html="article.content">加载中</div>
    </section>
    <section v-if="article.author" class="author">
      <span style="padding:0 5px;">{{article.author}}</span>
      <span style="padding-left:5px;" v-if="article.deceased">缅怀 {{article.deceased}}</span>
      <p>
        <span v-if="article.pub_text">{{article.pub_text}}</span>
      </p>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
const titleDOM = document.querySelector(`title`);
export default {
  data() {
    return {
      loading: false,
      visit: 0,
      article: {}
    };
  },
  computed: {
    api() {
      return this.$store.state.api;
    }
  },
  name: "home",
  components: {},
  methods: {
    async getArticle() {
      const { query } = this.$route;
      console.log(query, "query");
      const { id } = query;
      const response = await axios.get(`${this.api}/v1/article`, {
        params: { id }
      });

      const { data } = response;
      const article = data.data;
      if (article) {
        const { title, id } = article;
        this.$router.push({ query: { id } });
        this.article = article;
        titleDOM.innerText =`悼网·${title}` ;
      }
    }
  },
  async mounted() {
    await this.getArticle();

  }
};
</script>
<style lang="scss" scoped>
.bottom {
  padding-top: 5vh;
  position: relative;
  bottom: 0;
  text-align: center;
  width: 80vw;
  margin: 0 auto;
}
.home {
  margin: 0 auto;
  max-width: 600px;
  min-height: 100vh;
  padding-bottom: 10vh;
  .author {
    text-align: right;
    opacity: 0.5;
  }
  .content {
    text-align: justify;

    /deep/ p {
      text-indent: 2rem;
      &::selection {
        background: black;
        color: white;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .home {
    width: 90%;
    padding: 0 5%;
  }
}
@keyframes hrefAni {
  0% {
    padding: 3px;
  }
  50% {
    padding: 5px;
  }
  100% {
    padding: 3px;
  }
}
</style>
